import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'
import { UserData } from './trustedUserAuth'

const responseParser = (response: any) => {
  const { data } = response
  if (data.jfsUserId) {
    return data.jfsUserId
  } else {
    throw response
  }
}

const registerUser = (userData: UserData, authorizationCode: string, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.registerUser),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      authorizationCode: authorizationCode,
      user: {
        mobile: {
          mobileNumber: userData.mobile,
          countryCode: '91',
        },
        name: {
          firstName: userData.name,
          middleName: '',
          lastName: '',
        },
      },
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { registerUser }
